import moment from 'moment';

/**
 * 设置moment语言环境，用于解决日期选择器等语言问题
 */
export function setMomentLocale(lang: string) {
  const [locale] = lang.split('-');
  switch (locale) {
    case 'zh':
      // 中文简体/繁体都使用 ‘zh-CN’, 因为'zh'不生效, 'zh-TW'为英文字体。
      moment.locale('zh-CN');
      return;
    default:
      moment.locale(locale);
  }
}
